import React from "react";

import { IComplianceTrail } from "api/compliance/types";
import { TimelineRoot } from "components/ui/timeline";
import { START_INDEX } from "utils/constants";

import { COLORS } from "../consts";
import { ComplianceTrailTimelineItem } from "./ComplianceTrailTimelineItem";
import {
  IComplianceTrailTimelineItem,
  IComplianceTrailTimelineProps,
} from "./types";

const INDEX_OFFSET = 1;
const ZERO_INDEX = 0;
const nameColorMap: Record<string, string> = {};

const getColorForName = (name: string) => {
  if (nameColorMap[name]) {
    return nameColorMap[name];
  }

  const usedColors = Object.values(nameColorMap);
  const availableColors = COLORS.filter((color) => !usedColors.includes(color));

  // Select a color (use available or random from the list if all are used)
  const assignedColor =
    availableColors.length > ZERO_INDEX
      ? availableColors[ZERO_INDEX]
      : COLORS[Math.floor(Math.random() * COLORS.length)];

  // Assign and save the color for the name
  nameColorMap[name] = assignedColor;
  return assignedColor;
};

const addBgColorToAdminComplianceTrail = (
  data: IComplianceTrail[]
): IComplianceTrailTimelineItem[] => {
  return data.map((complianceTrail) => ({
    ...complianceTrail,
    bgColor: getColorForName(complianceTrail.adminName),
  }));
};

export const ComplianceTrailTimeline = (
  props: IComplianceTrailTimelineProps
) => {
  const { complianceTrails } = props;
  const complianceTrailsWithBgColor =
    addBgColorToAdminComplianceTrail(complianceTrails);

  return (
    <>
      <TimelineRoot
        maxW="508px"
        size="lg"
        variant="subtle"
      >
        {complianceTrailsWithBgColor.map((complianceTrail, index) => (
          <ComplianceTrailTimelineItem
            key={index}
            complianceTrail={complianceTrail}
            isFirstComplianceTrailItem={index === START_INDEX}
            isLastComplianceTrailItem={
              complianceTrails.length - INDEX_OFFSET === index
            }
          />
        ))}
      </TimelineRoot>
    </>
  );
};
